import { ElMessage, ElMessageBox } from "element-plus";
import AccountInfoPopover from "./AccountInfoPopover/index.vue";
import UpdatePasswordDialog from "./UpdatePasswordDialog/index.vue";
import UpdateKeyCodeDialog from "./UpdateKeyCodeDialog/index.vue";
import Auth from "../../../utils/auth";

import Api_Login from "../../../api/System/Login";

export default {
	name: 'ModuleBox',
	components: {
		AccountInfoPopover,
		UpdatePasswordDialog,
		UpdateKeyCodeDialog
	},
	data(){
		return{
			SystemLogoData:"",
			AdminPasswordDialogVisible:false,
			AdminKeyCodeDialogVisible:false,

			Info:JSON.parse(Auth.getInfo()),
			AdminName:'',
		}
	},
	methods:{
		GetSystemElement(){
			let RequestData = {};
			let ReturnData = Api_Login.GetSystemElement(RequestData);
			ReturnData.then(response => {
				let State = response['Data'][0].State;
				let Message = response['Data'][0].Message;
				//let Menu = response['Data'][0].Data.Menu;
				if(State == 'Success'){
					let Data = JSON.parse(response['Data'][0].Data);
					this.SystemLogoData = Data.SystemLogoData[0].Image.Url;
				}else{
					ElMessage.error(Message);
				}
			})
		},
	},
	mounted(){
		this.AdminName = this.Info.AdminName;
	},
    watch: {

    },
    emits:{
	
    }
}